// src/pages/Work/Work.js
import React, { useRef, useState, useEffect } from 'react';
import useScrollSpy from '../hooks/useScrollSpy';
import './Work.css';

import Overview from './Work/Overview/Overview';
import MyRole from './Work/MyRole/MyRole';
import MyUXProcess from './Work/MyUXProcess/MyUXProcess';
import UseCases from './Work/UseCases/UseCases';

import Sidebar from '../components/Sidebar/Sidebar';

function Work() {
    const sectionIds = [
    'overview',
    'myrole',
    'myuxprocess',
    'usecases',

    'devtools-overview',
    'devtools-specification',
    'devtools-problem',
    'devtools-process',
    'devtools-solution',
    'devtools-designfeatures',
    'devtools-conclusion',

    'desktopapp-overview',
    'desktopapp-specification',
    'desktopapp-problem',
    'desktopapp-process',
    'desktopapp-solution',
    'desktopapp-conclusion',

    'mobileapp-overview',
    'mobileapp-specification',
    'mobileapp-problem',
    'mobileapp-process',
    'mobileapp-solution',
    'mobileapp-designfeatures',
    'mobileapp-conclusion'
  ];
  const activeSection = useScrollSpy(sectionIds);
  const [selectedCase, setSelectedCase] = useState(null);

  // Create a ref for the UseCases component
  const useCasesRef = useRef(null);

  // Update selectedCase based on activeSection
  useEffect(() => {
    if (!activeSection) return;
    
    if (activeSection.startsWith('devtools-')) {
      setSelectedCase('devtools');
    } else if (activeSection.startsWith('desktopapp-')) {
      setSelectedCase('desktopapp');
    } else if (activeSection.startsWith('mobileapp-')) {
      setSelectedCase('mobileapp');
    } else {
      setSelectedCase(null);
    }
  }, [activeSection]);

  return (
    <div className="work-container">
      <Sidebar activeSection={activeSection} selectedCase={selectedCase} useCasesRef={useCasesRef} />

      <div className="work-content">
        <section id="overview">
          <Overview />
        </section>
        <section id="myrole">
          <MyRole />
        </section>
        <section id="myuxprocess">
          <MyUXProcess />
        </section>
        <section id="usecases">
          <UseCases ref={useCasesRef} onCaseSelect={setSelectedCase} />
        </section>
      </div>
    </div>
  );
}

export default Work;